export default class Network {
    // 오프라인 배너 표시 함수
    showOfflineBanner(){
        $('#offline-network-banner').show();
    }
    // 오프라인 배너 숨김 함수
    hideOfflineBanner(){
        $('#offline-network-banner').hide();
    }
    // 느린 네트워크 배너 표시 함수
    showSlowNetworkBanner() {
        $('#slow-network-banner').show();
    }

    // 느린 네트워크 배너 숨김 함수
    hideSlowNetworkBanner() {
        $('#slow-network-banner').hide();
    }

    // 오프라인 감지
    detectOfflineStatus() {
        if (!navigator.onLine) {
            this.showOfflineBanner();
        } else {
            this.hideOfflineBanner();
        }

        // 네트워크 상태 변경 이벤트 등록
        window.addEventListener('online', () => {
            this.hideOfflineBanner();
        });

        window.addEventListener('offline', () => {
            this.showOfflineBanner();
        });
    }

    // 느린 네트워크 감지
    detectSlowNetwork() {
        const slowRtt = 800;
        if ('connection' in navigator) {
            const connection = navigator.connection;

            if (connection.rtt >= slowRtt ) {
                this.showSlowNetworkBanner();
            } else {
                this.hideSlowNetworkBanner();
            }

            connection.addEventListener('change', () => {
                if (connection.rtt >= slowRtt) {
                    this.showSlowNetworkBanner();
                } else {
                    this.hideSlowNetworkBanner();
                }
            });
        } else {
            console.log('Network Information API를 지원하지 않는 브라우저입니다.');
        }
    }

    /**
     * Ajax 통신시 세션 만료(401/419)를 인지해 로그인으로 넘긴다.
     *
     * 끊긴 세션이 드러나는 경우가 둘인데 사용자 입장이 달라 처리도 가른다.
     *
     * 1) 백그라운드 — 오랜만에 앱을 켜면 PHP 세션이 끊겨 있다. 화면에 남아있던(=MEMBER.num>0)
     *    페이지가 자동으로 쏘는 GPS 갱신·폴링이 401 을 받는다. 사용자는 아무것도 누르지 않았으니
     *    알림 없이 /m/login 으로 넘긴다 — 60일 자동로그인 쿠키가 살아있으면 로그인 화면도 안 거치고
     *    소리없이 다시 로그인되어 reurl(보던 페이지)로 돌아온다.
     *
     * 2) 사용자 동작 — 버튼을 눌러(수주·저장 등) 쏜 ajax 가 만료로 실패한 경우. 말없이 넘기면
     *    "방금 누른 게 됐나?" 를 알 수 없다. 처리되지 않았음을 분명히 알린 뒤 넘긴다.
     *
     * 둘은 '방금 손으로 한 동작이 있었나'(최근 제스처)로 가른다 — 호출부마다 표시하지 않아도 갈린다.
     * 동시 401 이 여러 번 와도 한 번만 처리한다.
     *
     * @param {Object}  [opts]
     * @param {string}  [opts.loginUrl='/m/login'] 자동로그인을 돌릴 로그인 화면. 악덕(/b)은 '/b/login'
     *                  — 자동로그인 쿠키는 그 사이트 로그인 화면을 열 때만 돈다(ajax 는 401 만 받는다).
     * @param {boolean} [opts.sessionOnly=false] 세션 끊김(401/419)만 맡는다. 악덕(/b)은 다른 실패를
     *                  화면마다 '불러오기 실패' 로 이미 알리므로 네트워크·500 알럿을 겹쳐 띄우지 않는다.
     */
    setupAjax({ loginUrl = '/m/login', sessionOnly = false } = {}){
        let handled = false;
        // 탭/키입력/폼제출 시각 — 직후(6초 내)의 ajax 는 사용자가 유발한 것으로 본다.
        // 앱 재실행 시 자동으로 도는 GPS·폴링엔 앞선 제스처가 없어 백그라운드로 갈린다.
        let lastGesture = 0;
        ['pointerdown', 'keydown', 'submit'].forEach((t) =>
            document.addEventListener(t, () => { lastGesture = Date.now(); }, true));

        const goLogin = () => {
            const reurl = encodeURIComponent(location.pathname + location.search + location.hash);
            location.replace(loginUrl + '?reurl=' + reurl);
        };

        $.ajaxSetup({
            error: function(jqXHR, textStatus, errorThrown) {
                const expired = jqXHR.status === 401 || jqXHR.status === 419;
                if (sessionOnly && !expired) return;
                if (!navigator.onLine) {
                    // alert("네트워크 연결이 끊어졌습니다. 인터넷을 확인해주세요.");
                } else if (expired) {
                    if( handled || typeof MEMBER === 'undefined' || !MEMBER || !(MEMBER.num > 0) ) return;
                    handled = true;
                    const userInitiated = Date.now() - lastGesture < 6000;
                    if (userInitiated && window.$j && $j.Ui && $j.Ui.Dialog) {
                        $j.Ui.Dialog
                            .alert('로그인 세션이 만료되어 방금 요청이 처리되지 않았습니다. 다시 로그인해 주세요.')
                            .then(goLogin);
                    } else {
                        goLogin();
                    }
                } else if (jqXHR.status === 0) {
                    alert("인터넷 연결이 원활하지 않습니다. 연결확인 후 다시 시도해주세요.");
                } else if (jqXHR.status === 500) {
                    alert("서버에서 문제가 발생했습니다. 관리자에게 문의하세요.");
                } else if (jqXHR.status === 429) {
                    alert("잠시 후 다시 시도해주세요.");
                } else {
                    // alert("알 수 없는 오류가 발생했습니다.");
                    console.error("Ajax Error:", textStatus, errorThrown);
                }
            }
        });
    }

    // 초기화 함수
    start() {
        this.setupAjax();
        this.detectOfflineStatus();
        this.detectSlowNetwork();
    }
}